module.exports = __webpack_public_path__ + "plus.bf51364e3a3320f47b5d2f7bdf712f99.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plus.svg
// module id = 80
// module chunks = 0